import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

const StickyCartFooter = () => {
  const { cartItems, cartTotal } = useCart();

  if (cartItems.length === 0) {
    return null;
  }

  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 border-t-2 border-red-600 z-50">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <ShoppingCart className="text-red-600" size={24} />
          <span className="text-sm font-bold sm:text-base">{totalItems} items</span>
        </div>
        <div className="text-xl font-bold text-red-600">
          Total: ₹{cartTotal.toFixed(2)}
        </div>
        {/* Corrected path to Checkout page */}
        <Link to="/checkout" className="bg-green-500 text-white font-bold py-2 px-4 rounded-full hover:bg-green-600 transition-colors duration-200">
          Checkout
        </Link>
      </div>
    </div>
  );
};

export default StickyCartFooter;